/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider as AlertProvider} from 'react-alert'
import {alertOptions} from "./js/style/AlertStyle.js";
import AlertTemplate from "react-alert-template-basic";

ReactDOM.render(
  <React.StrictMode>
      <AlertProvider template={AlertTemplate} {...alertOptions}>
        <App />
      </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
